// содержимое .docx преобразуем в html через сервис wordhtml.com

export const eulaEn = `<p><strong>LICENSE AGREEMENT <br /> WITH END USER of cyber training <br /> software package </strong></p>
<p><strong>Solar Cybermir</strong></p>
<p><strong><br /> ATTENTION! Please read the following carefully before reproducing, copying or otherwise using the software of the Solar Cybermir Cyber Training software package (hereinafter referred to as the "Software"). </strong></p>
<p><br /> This License Agreement with the End User (hereinafter referred to as the "Agreement") regulates the relations that arise between the Company and you, an individual or a legal entity (regardless of nationality or jurisdiction), and defines the procedure and conditions for your use of the Software. The agreement is concluded in a simplified manner and is an accession agreement, the terms of which are set out in electronic form and brought to your attention.</p>
<p><br /> The Agreement comes into force from the moment when you start using the Software, or, if provided for by the functionality of the Software, from the moment when you accept the terms of the Agreement, by ticking during the installation of the Software on your device the item "I agree to the terms of the License Agreement" or "I accept the terms of the License Agreement" or other proposed way, you express your consent on the screen of your device using the software installation interface. The Agreement set out in electronic form, upon your acceptance, as indicated above, is considered concluded in writing in accordance with paragraph 3 of Article 434 and paragraph 3 of Article 438, paragraph 5 of Article 1286 of the Civil Code of the Russian Federation and is regulated in accordance with the law of the Russian Federation.</p>
<p><strong><br /> In any case, the start of using the Software means your full and unconditional acceptance of the terms of the Agreement. You confirm that you have read the Agreement, that you understand its terms and conditions and that you fully agree with them. If you do not agree to the terms of the Agreement, do not use the Software.</strong></p>
<p><br /> The granting of rights to use the Software may be accompanied by a separate agreement concluded between the Company or a Partner of the Company and/or you. In case of discrepancies in the content between the text of the Agreement in electronic form and the text of the corresponding separate agreement (license agreement), the text of the separate agreement (usually drawn up in paper form and signed by the parties to the agreement) shall prevail, except for the terms of guarantees and obligations of the User (clause 3.3. of the Agreement). This requirement applies to all users equally.</p>
<p><br /> The rights to the Software (including the right to software subsystems, updates, any adaptations and modifications of the software, etc.) are protected by the legislation of the Russian Federation and international agreements. Some parts (components) of the Software may be protected by patent and know-how legislation. Violation of the terms of the Agreement and the rights to the Software entails liability provided for by the Agreement and the legislation of the Russian Federation.</p>
<ol>
<li><strong><br /> TERMS AND DEFINITIONS</strong></li>
</ol>
<p>1.1. "<strong>Company"</strong> is SOLAR SECURITY Limited Liability Company (SOLAR SECURITY LLC), a legal entity registered and operating in accordance with the legislation of the Russian Federation, the main state registration number (OGRN) 1157746204230, registered at: 127015, Moscow, 35 Vyatskaya str., bld. 4, fl. 4, sp. 7, room 12, 20-23, 25-34, 48-54, 65. The company is the copyright holder of the Solar Cybermir Cyber Training Software Package, subsystems, updates, etc.</p>
<p><br /> 1.2. <strong>"Solar Cybermir Cyber Training Software Package", "SOFTWARE"</strong> is software owned by the Company (including any and every modified version, unless expressly otherwise specified in a separate agreement), including a set of software subsystems, updates, etc., which are objects of intellectual property (computer programs).</p>
<p>Any mention of the Solar Cybermir cyber training software package implies any subsystems, updates, etc., or their combination, as well as any derivative of this software (modified and/or adapted versions) rights to which you have obtained under a license agreement with the Company or a Partner of the Company.</p>
<p>1.3. "<strong>You", "User"</strong> is any natural and/or legal person (organization) who purchased and/or gained access to the Software for their own use.</p>
<p>1.4. <strong>"License"</strong> means the limited right (permission) granted to you by the Company to install, run and use the functionality of the Software (subsystem) under the terms of a simple (non-exclusive) license.</p>
<p>1.5. "<strong>Partner"</strong> is a legal entity to which the Company has granted the right to distribute and otherwise use the Software.</p>
<p>1.6. <strong>"Device"</strong> means the physical or virtual device through which you use the Software.</p>
<p>1.7. <strong>The software licensing metric is the</strong> amount of software usage, which is defined in a separate license agreement with the Company.</p>
<p>1.7.1. Types of software licensing metrics:</p>
<p>- <strong>by the number of simultaneous users grouped into teams and having access to the software functionality</strong> (simultaneous users in this case are understood to be an account in the software that provides access to the software functionality and uses the software at a separate time; commands are understood to be a group of account users united by a single functionality);</p>
<p>- by the number of simultaneous users (in this case, a user is an account created using the software functionality);</p>
<p>- a different licensing metric specified in a separate agreement with the Company.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<ol start="2">
<li><strong> SOFTWARE LICENSE</strong></li>
</ol>
<p><br /> 2.1. The Company grants you the right to use the Software for a period established by a separate agreement with the Partner and/or you. The use of the Software is provided in the territory defined in a separate agreement, and provides for such methods of use as: installation (reproduction and installation), launch and use of the Software functionality in accordance with the terms of the Agreement. Additional uses must also be specified in a separate agreement. The methods of use that are not specified in a separate agreement and/or in this document are considered to be unreported neither to you nor to the Partner.</p>
<p>The rights specified in this paragraph relate to 1 (One) copy of the Software, which is installed on 1 (One) device with the maximum amount of rights available at the time of granting the right in relation to the software functionality and a set of subsystems.</p>
<p>Any other parameters for using the Software must be explicitly specified in a separate agreement with the Company or a Partner of the Company.</p>
<p>2.2. Any use of the Software or Software components in violation of the terms of the Agreement or a separate license agreement concluded by you with the Company or a Partner of the Company is a violation of the exclusive rights of the Company and/or third parties and serves as a basis for the unilateral termination of your right to use the Software by the Company, as well as the application of other liability measures provided for by the legislation of the Russian Federation.</p>
<p>2.3. The Company reserves all rights to the Software, to any modified and adapted versions of such Software. Nothing in the Agreement can be interpreted as transfer (alienation) of the exclusive rights to the Software (including rights to modified/adapted versions of the Software) to you.</p>
<p>2.4. The License fee is not paid by the User under the Agreement, unless otherwise follows from the circumstances of the Software offer.</p>
<ol start="3">
<li><strong><br /> GUARANTEES AND OBLIGATIONS</strong></li>
</ol>
<p><strong><br /> 3.1. Guarantees and obligations of the Company:</strong></p>
<p>3.1.1. The Company guarantees that it has all the necessary rights to the Software and its components, as well as (if available) to the documentation, materials, and images accompanying the Software.</p>
<p>3.1.2. The Company cannot and does not guarantee the results that you can get when using the Software, as well as that the work of the Software will meet your requirements and expectations or the level and functionality of such programs developed by third parties.</p>
<p>3.1.3. The Company provides the "AS IS" Software, does not and cannot provide guarantees not specifically stipulated in the Agreement, including regarding Software components, and also does not guarantee full and uninterrupted work, performance and results that you can get through the use of software, software subsystems, updates and/or new minor versions of the Software.</p>
<p>3.1.4. The Company does not provide any guarantees regarding the third-party software used in the Software or supplied (transferred) from the Software, including the satisfactory operation of such software.</p>
<p>3.1.5. The Company cannot and does not guarantee that the Software is error-free or that the Software will function normally when used in conjunction with other software. The Company cannot and does not guarantee that the Software will function normally when used on operating systems and hardware that are not listed as compatible with the Software.</p>
<p>3.1.6. If the Software was purchased on a tangible medium, as well as if this is required by the applicable law of the country where the rights to the Software were acquired, the Company guarantees the quality and operability of the tangible media on which the Software was provided.</p>
<p>3.1.7. The Company, within 1 (one) year from the date of purchase of the Software, performs fixing bugs made during the development process and hindering the normal operation of the Software by the User. Bug fixing is not a technical support service. The deadline for the elimination of identified software bugs is set by the Company. In order to report a software bug, the User must send an appropriate request to the email address <a href="mailto:support@rt-solar.ru">support@rt-solar.ru</a> .</p>
<p>3.1.8. Any other services associated with and related to the use of the Software must be purchased separately.</p>
<p><strong><br /> 3.2. The Company has the right to:</strong></p>
<p>3.2.1. Terminate the Agreement unilaterally, out of court, in case of violation of the terms of use of the Software by the User. Termination of the Agreement entails the impossibility of further use of the Software and cancellation of the License granted.</p>
<p>3.2.2. Send the User informational and promotional messages by e-mail containing news about the Company's products and services, including after the User stops using the Software.</p>
<p><strong>3.3. Guarantees and obligations of the User:</strong></p>
<p>3.3.1. The User undertakes to use the Software in accordance with the terms of the Agreement, exclusively for legitimate purposes.</p>
<p>3.3.2. The User undertakes not to perform independently and not to assist third parties the following actions:</p>
<p>3.3.2.1. To study, investigate or test the functionality of the Software in order to determine the ideas and principles underlying any element or component of the Software, disassemble, decompile (reproduce and convert object code into source code) or otherwise attempt to obtain the source code of the Software or any part of the Software, except as permitted by applicable law, despite this limitation, and only to the extent permitted by applicable law. If applicable law prohibits the restriction of these actions, any information obtained in this way (i) should not be used to create software that is substantially similar in appearance to the Software or to perform other actions that violate the Company's exclusive right to the Software or the rights of the authors of the Software, (ii) should not be disclosed to third parties if only such disclosure is not provided for by applicable law, and (iii) must be immediately notified to the Company.</p>
<p>Any information obtained by the User as a result of the actions specified in this paragraph is confidential and belongs to the Company.</p>
<p>If the decompilation of the Software is required by the User in order to achieve the ability to interact with other software programs, the User must contact the Company with a written request to perform these actions. The Company undertakes to take reasonable and economically reasonable measures to ensure the interaction of the Software with the User's programs. The User can decompile the Software for the above purposes only if the Company refuses in writing to take appropriate measures.</p>
<p>3.3.2.2. To modify, adapt (including making changes to the Software solely for the purpose of its functioning on specific User hardware or under the control of specific User programs), make any changes to the object code of the software, programs and databases contained in the Software, except for those changes that are provided for by the Software and described in the documentation. Any changes made at the User's request do not entail the transfer of the exclusive right to such a modified version to the User's address. The exclusive right to the modified version belongs to the Company, unless otherwise expressly provided in the license agreement;</p>
<p>3.3.2.3. To correct errors in the Software or to translate the Software without the prior written consent of the Company;</p>
<p>3.3.2.4. To lease, sublicense, transfer or assign the rights granted to you under the Agreement and any other rights related to the Software to any other person, as well as to allow copying the Software, modules (subsystems) or parts to other Devices, unless otherwise agreed in a separate written agreement with the Company or a Partner of the Company;</p>
<p>3.3.2.5. To distribute the Software for the benefit of third parties on a reimbursable or gratuitous basis;<br /> 3.3.2.6. To create conditions for access to the Software or use of the Software by third parties who do not have the rights to use this software;</p>
<p>3.3.2.7. To independently delete, modify or obscure any copyright, trademark or patent notices that are indicated on the Software provided to you. If such changes are made by the Company at the request of the User, this does not mean the termination of the Company's right to the Software and the transfer of exclusive rights to the Software to the User;</p>
<p>3.3.2.8. To use the Software to provide paid or free services.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<ol start="4">
<li><strong> SOFTWARE TRIAL VERSION </strong></li>
</ol>
<p>4.1. The Company has the right to provide the User with Software that is a trial version. The specified Software may have a limited validity period, an incomplete set of functionality. The trial version of the software is intended for testing, familiarization or demonstration of the functionality of the software.</p>
<p>4.2. If the Software specified in clause 4.1. is provided to the User on a tangible medium, it can be labeled as a "Test version", "Trial version" (or "Trial").</p>
<p>4.3. The Company does not charge remuneration for granting the right to use the trial version of the Software, unless otherwise follows from a separate license agreement or is not established when offering the use of the trial version of the Software.</p>
<p>4.4. If the trial version of the Software is provided, a separate license agreement may be concluded with the User, regulating the procedure and conditions for using such a version of the Software. If a separate license agreement has been concluded with the User, the terms of such agreement shall prevail.</p>
<p>4.5. The trial version of the Software is subject to the guarantees provided for in clause 3.1. of the Agreement.<br /> 4.6.&nbsp; With respect to the trial version of the Software, the User has the same responsibilities and provides the same guarantees as described in clause 3.3 of the Agreement.</p>
<p><strong>&nbsp;</strong></p>
<ol start="5">
<li><strong> RESPONSIBILITY OF PARTIES</strong></li>
</ol>
<p>5.1. In case of violation of the terms of the Agreement, the Parties are responsible in accordance with the terms of the Agreement, a separate license agreement, as well as the legislation of the Russian Federation.</p>
<p>5.2. The Company is not responsible for losses, forced business interruptions, data loss, third-party claims or expenses, indirect or incidental damages, as well as for lost profits and lost savings caused by the use or inability to use the Software, as well as for damage caused by possible errors and typos in the Software. These restrictions apply to the extent permitted by applicable law. In any case, the Company's liability is limited to the amount that the User paid for the granted right in favor of the Company, or the amount that the Partner paid in favor of the Company for the granted right to use the Software, which was subsequently transferred (sublicensed) to the User.</p>
<p>5.3. The Company is not responsible for the legality of the use of the Software by the User in relation to third parties (employees of the User, etc.). The User is solely responsible to third parties whose rights he has violated in connection with the Use of the Software and the results obtained while using the Software.</p>
<p>5.4. In case of violation of the terms of the Agreement, a separate license agreement or the legislation of the Russian Federation when using the Software, the User undertakes to reimburse the Company for all losses caused, including real damage and lost profits.</p>
<p>&nbsp;</p>
<ol start="6">
<li><strong> INTELLECTUAL PROPERTY</strong></li>
</ol>
<p>6.1. The Company is the owner of the exclusive right to the Software in respect of which you accept the Agreement (the copyright holder of the Software). In accordance with Article 1229 of the Civil Code of the Russian Federation, other persons may not use the corresponding result of intellectual activity if such use is carried out without the consent of the copyright holder.</p>
<p>6.2. Product names, as well as other designations in the Software, may be trademarks of their <br /> respective owners. All trademarks of the Company are its intellectual property and are provided for your information. The Company does not grant you any rights with respect to the Company's trademarks.</p>
<p>6.3. The Company confirms that the intellectual <br /> property of third parties (software, software components, libraries, etc.) specified in Appendix No. 1 to the Agreement were used in the creation of the Software. With respect to intellectual property objects of third parties used in the Software, the User is charged with the same obligations as provided for in clause 3.3.2 of the Agreement.</p>
<p>6.4. The Company informs that the Software may mention trademarks (service marks) of third parties. All mentioned trademarks (service marks) are the intellectual property of their respective owners and are provided for your information. Nothing in the Agreement shall be construed as granting you any rights in respect of such trademarks (service marks) or otherwise disposing of any rights in such trademarks (service marks).</p>
<p>Absence of mentioning any other trademarks (service marks) in the Software does not mean that they are not subject to restrictions and prohibitions provided by the Agreement in respect of third party trademarks (service marks).</p>
<p>6.5. The same terms and conditions of the Agreement apply to any modified, adapted or software products other than the reference version. Nothing (including any specific actions) can be interpreted by the Parties as alienation of exclusive rights to such modified versions to the User. All rights to any derivative versions belong to SOLAR SECURITY LLC. Otherwise, it must be explicitly stated in the terms of the License Agreement.</p>
<ol start="7">
<li><strong><br /> TERMINATION OF AGREEMENT</strong></li>
</ol>
<p><br /> 7.1. Unless otherwise specified in a separate agreement with Company or a Company Partner, the Agreement is valid for the term of the Software license granted to you, or until terminated.</p>
<p>7.2. The User can terminate the Agreement by stopping the use of the Software and uninstalling the Software from the Devices, as well as destroying all copies of the Software (including archived ones) from Devices.<br /> 7.3. At the Company's option, if the User violates any of the terms and conditions stipulated in the Agreement, the Company has the right to terminate the Agreement by notifying the User by e-mail, or in writing on paper, or, if applicable and technically feasible, by blocking the User's login and password and notifying the User of the reasons.&nbsp;</p>
<p>&nbsp;</p>
<ol start="8">
<li><strong> APPLICABLE LAW AND DISPUTE RESOLUTION</strong></li>
</ol>
<p><strong>&nbsp;</strong></p>
<p>8.1. The legislation of the Russian Federation applies to the terms of the Agreement and obligations arising from the Agreement.</p>
<p>8.2. The following mandatory claim procedure is established for the resolution of disputes arising between the User and the Company in connection with the use of the Software:</p>
<p>8.2.1. The User who believes that his/her rights and interests have been violated in connection with the use of the Software shall send a claim to the Company to the e-mail address: info@rt-solar.ru.</p>
<p>8.2.2. Not later than 30 (Thirty) business days from the date of receipt of the claim, the Company shall prepare and send to the User a reply or request for additional information to the User's return address (from which the User's claim was received), or to the address specified by the User in the claim.</p>
<p>8.2.3.&nbsp; The Company does not consider anonymous claims or claims that do not allow to identify the User on the basis of the data provided by the User in the claim.</p>
<p>8.2.4. In case of failure to reach a dispute resolution through the claim procedure, the dispute shall be considered in accordance with the legislation of the Russian Federation, at the location of the Company.</p>
<p>8.3. If the Company has been sued by third parties in connection with the misuse of the Software by the User, the latter undertakes to compensate any costs and expenses of the Company (including legal fees, remuneration to consultants, representatives and lawyers representing the interests of the Company, remuneration of auditors).</p>
<ol start="9">
<li><strong><br /> OTHER CONDITIONS</strong></li>
</ol>
<p><br /> 9.1. Nothing in the Agreement shall be construed as establishing between the User and the Company an agency, partnership, joint venture, personal employment relationship, or any other relationship not expressly provided for in the Agreement. The Parties acknowledge that the Agreement is essentially a license agreement, that is, aimed at granting the rights to use an intellectual property object under certain conditions. The use of the words "sell", "buy" and other similar expressions in relation to the Agreement, relations of the parties anywhere (including, but not limited to, in promotional materials, presentations) does not mean the expression of the Company's will to change the essence and recharacterization of the Agreement.</p>
<p>9.2. Recognition by a court of law of any provision of the Agreement as invalid or unenforceable shall not invalidate other provisions of the Agreement <br /> 9.3. <strong>You consent to:</strong></p>
<p><strong>"a"</strong> the voluntary transfer of your personal data to the Company, if the <br /> provision of relevant personal data is necessary to start using the Software. You consent to the processing (including, but not limited to, the collection and other use) of your personal data by the Company and/or its affiliates in accordance with applicable law and subject to confidentiality and data protection in accordance with applicable law. Any personal data provided by you to the Company will be stored and used only by the Company and/or its affiliates and will not be provided to third parties, except as required by applicable law. All personal data will be processed solely for the purpose of fulfilling the Company's obligations under the Agreement or other agreements concluded between the User and the Company in connection with the use of the Software. If you provide, among other things, information about a legal entity, you confirm that you have sufficient authority for this, and the information you provide is complete and reliable;</p>
<p><strong>"b"</strong> receiving promotional messages about the Company's products and services over telecommunication networks, including after the Software is discontinued.</p>
<p><strong>9.4. Company contact information:<br /> </strong>SOLAR SECURITY Limited Liability Company (SOLAR SECURITY LLC)<br /> Location address: 127015, Moscow, Vyatskaya str., 35 <br /> p. 4, fl. 4, room 7, com. 12, 20-23, 25-34, 48-54, 65 Postal address: 125009, Moscow, Nikitsky Lane, 7, building 1 <br /> Contact phone/fax: +7 (495) 755-07-70 <br /> e-mail: info@rt-solar.ru <br /> Document update date: 25.12.2023</p>
<p>&nbsp;</p>
<p><strong>Appendix No. 1</strong></p>
<p><strong>to the Agreement</strong></p>
<p><strong>&nbsp;</strong></p>
<p><strong>Intellectual property objects of third parties of the software server part</strong></p>
<table>
<thead>
<tr>
<td width="232">
<p><strong>Name of the intellectual property</strong></p>
</td>
<td width="429">
<p><strong>Notification</strong></p>
</td>
</tr>
</thead>
<tbody>
<tr>
<td width="232">
<p>io.netty</p>
</td>
<td width="429">
<p>Copyright &copy; 2023 The Netty project.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://netty.io">https://netty.io</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>ch.qos.logback</p>
</td>
<td width="429">
<p>Copyright &copy; QOS.CH.</p>
<p>Licensed under the Eclipse Public License - v 1.0</p>
<p><a href="http://www.eclipse.org/legal/epl-v10.html">http://www.eclipse.org/legal/epl-v10.html</a>.</p>
<p>Licensed under the GNU Lesser General Public License</p>
<p><a href="http://www.gnu.org/licenses/old-licenses/lgpl-2.1.html">http://www.gnu.org/licenses/old-licenses/lgpl-2.1.html</a>.</p>
<p>Copyright holder's website: <a href="http://logback.qos.ch">http://logback.qos.ch</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.micrometer</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; 2017 - 2023 Vmware.</p>
<p>Licensed under the Apache Software License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: https://micrometer.io,</p>
<p><a href="https://github.com/micrometer-metrics/micrometer">https://github.com/micrometer-metrics/micrometer</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.prometheus</p>
</td>
<td width="429">
<p>Copyright &copy; Brian Brazil, Matt T. Proud.</p>
<p>Licensed under the Apache Software License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/prometheus/client_java">https://github.com/prometheus/client_java</a> .</p>
<p><strong>&nbsp;</strong></p>
</td>
</tr>
<tr>
<td width="232">
<p>jakarta.annotation</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation working group Jakarta EE.</p>
<p>Licensed under the EPL 2.0<a href="http://www.eclipse.org/legal/epl-2.0"><br /> http://www.eclipse.org/legal/epl-2.0</a>.</p>
<p>Licensed under the GPL2 w/CPE<a href="https://www.gnu.org/software/classpath/license.html"><br /> https://www.gnu.org/software/classpath/license.html</a>.</p>
<p>Copyright holder's website: <a href="https://jakarta.ee">https://jakarta.ee</a>,</p>
<p><a href="https://www.eclipse.org">https://www.eclipse.org</a>.</p>
<p><strong>&nbsp;</strong></p>
</td>
</tr>
<tr>
<td width="232">
<p>org.apache.logging.log4j</p>
</td>
<td width="429">
<p>Copyright &copy; Ralph Goers (Nextiva), Gary Gregory (The Apache Software Foundation), Scott Deboy, Remko Popma, Nick Williams, Matt Sicker (Apple), Bruce Brouwer, Mikael St&aring;ldal (Spotify), Carter Kozak, Volkan Yazıcı, Ron Grabowski.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/apache/logging-log4j2">https://github.com/apache/logging-log4j2</a> .</p>
<p><strong>&nbsp;</strong></p>
</td>
</tr>
<tr>
<td width="232">
<p>org.hdrhistogram</p>
</td>
<td width="429">
<p>Copyright &copy; Creative Commons Attribution 2012, 2013, 2014, 2015, 2016, Developer: Gil Tene.</p>
<p>Copyright &copy; 2014 Michael Barker, Copyright &copy; 2014 Matt Warren.</p>
<p>Licensed under the BSD-2-Clause<a href="https://opensource.org/licenses/BSD-2-Clause"><br /> https://opensource.org/licenses/BSD-2-Clause</a>.</p>
<p>Licensed under the Public Domain per Creative Commons CC0</p>
<p><a href="http://creativecommons.org/publicdomain/zero/1.0.">http://creativecommons.org/publicdomain/zero/1.0.</a></p>
<p>Copyright holder's website: <a href="https://creativecommons.org">https://creativecommons.org</a> .</p>
<p><strong>&nbsp;</strong></p>
</td>
</tr>
<tr>
<td width="232">
<p>org.slf4j</p>
</td>
<td width="429">
<p>Copyright &copy; QOS.CH.</p>
<p>Licensed under the MIT License<a href="http://www.opensource.org/licenses/mit-license.php"><br /> http://www.opensource.org/licenses/mit-license.php</a>.</p>
<p>Copyright holder's websites: <a href="http://logback.qos.ch">http://logback.qos.ch</a>,</p>
<p><a href="https://www.slf4j.org">https://www.slf4j.org</a>.</p>
<p><strong>&nbsp;</strong></p>
</td>
</tr>
<tr>
<td width="232">
<p>org.springframework</p>
<p>&nbsp;</p>
<p>org.springframework.boot</p>
<p><strong>&nbsp;</strong></p>
<p>org.springframework.cloud</p>
<p>&nbsp;</p>
<p>org.springframework.security</p>
<p>&nbsp;</p>
<p>org.springframework.data</p>
<p><strong>&nbsp;</strong></p>
</td>
<td width="429">
<p>Copyright &copy; Pivotal Software, Inc.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's websites: <a href="https://spring.io">https://spring.io</a> , <a href="https://github.com/spring-projects/spring-framework">https://github.com/spring-projects/spring-framework</a> , <a href="https://spring.io/projects/spring-cloud">https://spring.io/projects/spring-cloud</a> , <a href="https://spring.io/projects/spring-security">https://spring.io/projects/spring-security</a>,</p>
<p><a href="https://projects.spring.io/spring-data-jdbc">https://projects.spring.io/spring-data-jdbc</a>.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>&nbsp;</strong></p>
</td>
</tr>
<tr>
<td width="232">
<p>org.yaml:snakeyaml</p>
</td>
<td width="429">
<p>Copyright &copy; 2023 Andrey Somov, Alexander Maslov.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://mvnrepository.com/artifact/org.yaml/snakeyaml/2.2">https://mvnrepository.com/artifact/org.yaml/snakeyaml/2.2</a> .</p>
<p><strong>&nbsp;</strong></p>
</td>
</tr>
<tr>
<td width="232">
<p>com.fasterxml</p>
</td>
<td width="429">
<p>Copyright &copy; 2023 Tatu Saloranta, Brian Langel,Tatu Saloranta.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/FasterXML/java-classmate">https://github.com/FasterXML/java-classmate</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>jakarta.validation</p>
</td>
<td width="429">
<p>Copyright &copy; Red Hat, Inc.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://beanvalidation.org">https://beanvalidation.org</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.apache.tomcat.embed</p>
</td>
<td width="429">
<p>Copyright &copy; 1999-2023, The Apache Software Foundation.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://tomcat.apache.org">https://tomcat.apache.org</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.hibernate.validator</p>
</td>
<td width="429">
<p>Copyright &copy; Red Hat, Inc.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://hibernate.org/validator/releases/6.2">https://hibernate.org/validator/releases/6.2</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.jboss.logging</p>
</td>
<td width="429">
<p>Copyright &copy; JBoss.org Community.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="http://www.jboss.org">http://www.jboss.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.jetbrains</p>
</td>
<td width="429">
<p>Copyright &copy; JetBrains Team.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/JetBrains/java-annotations">https://github.com/JetBrains/java-annotations</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.evolvedbinary.thirdparty.org.apache.xmlrpc</p>
</td>
<td width="429">
<p>Copyright &copy; Apache XML RPC Client Library.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website:</p>
<p><a href="https://mvnrepository.com/artifact/com.evolvedbinary.thirdparty.org.apache.xmlrpc/xmlrpc-client/5.0.0">https://mvnrepository.com/artifact/com.evolvedbinary.thirdparty.org.apache.xmlrpc/xmlrpc-client/5.0.0</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.fasterxml.jackson.dataformat</p>
<p>&nbsp;</p>
<p>com.fasterxml.jackson.datatype</p>
<p>&nbsp;</p>
<p>com.fasterxml.jackson.module</p>
</td>
<td width="429">
<p>Copyright &copy;2009-2011 FasterXML, LLC.</p>
<p>Developer: Tatu Saloranta.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's websites:</p>
<p><a href="https://github.com/FasterXML/jackson-dataformat-xml">https://github.com/FasterXML/jackson-dataformat-xml</a>, <a href="https://github.com/FasterXML/jackson-modules-java8">https://github.com/FasterXML/jackson-modules-java8</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.fasterxml.woodstox</p>
</td>
<td width="429">
<p>Copyright &copy;2009-2011 FasterXML, LLC.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website:</p>
<p><a href="https://github.com/FasterXML/woodstox">https://github.com/FasterXML/woodstox</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.github.fge</p>
</td>
<td width="429">
<p>Copyright &copy; Francis Galiegue.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Lesser General Public License, version 3 or greater.</p>
<p>Copyright holder's website:</p>
<p><a href="https://github.com/fge/btf">https://github.com/fge/btf</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.github.openstack4j.core</p>
</td>
<td width="429">
<p>Copyright &copy; Jeremy Unruh.</p>
<p>Licensed under the MIT License</p>
<p>https://opensource.org/license/mit.</p>
<p>Copyright holder's website: <a href="https://github.com/openstack4j/openstack4j">https://github.com/openstack4j/openstack4j</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.google.code.findbugs</p>
</td>
<td width="429">
<p>Copyright &copy; Bill Pugh,&nbsp;Andrey Loskutov.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="http://findbugs.sourceforge.net">http://findbugs.sourceforge.net</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.google.errorprone</p>
</td>
<td width="429">
<p>Copyright &copy; Error Prone Group.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/google/error-prone">https://github.com/google/error-prone</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.google.guava</p>
</td>
<td width="429">
<p>Copyright &copy; 2019 The Guava Authors</p>
<p>Developer and owner: Francis Galiegue (Google LLC).</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/google/guava/releases?after=v24.1.1">https://github.com/google/guava/releases?after=v24.1.1</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.google.j2objc</p>
</td>
<td width="429">
<p>Copyright &copy; Google LLC.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/google/j2objc">https://github.com/google/j2objc</a></p>
<p>.</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.jcraft:jsch</p>
</td>
<td width="429">
<p>Copyright &copy; 1998-2016 JCraft, Inc.</p>
<p>Licensed under the Revised BSD</p>
<p><a href="http://www.jcraft.com/jsch/LICENSE.txt">http://www.jcraft.com/jsch/LICENSE.txt</a>.</p>
<p>Copyright holder's website: <a href="http://www.jcraft.com/jsch">http://www.jcraft.com/jsch</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>commons-codec</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://commons.apache.org/proper/commons-codec">https://commons.apache.org/proper/commons-codec</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>junit:junit</p>
</td>
<td width="429">
<p>Copyright &copy; Junit Group.</p>
<p>Licensed under the Eclipse Public License 1.0<a href="http://www.eclipse.org/legal/epl-v10.html"><br /> http://www.eclipse.org/legal/epl-v10.html</a>.</p>
<p>Copyright holder's website: <a href="http://junit.org">http://junit.org</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.apache.httpcomponents</p>
<p>&nbsp;</p>
<p>org.apache.httpcomponents</p>
<p>&nbsp;</p>
<p>org.apache.ws.commons.util</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="http://hc.apache.org/httpcomponents-client">http://hc.apache.org/httpcomponents-client</a> ,</p>
<p><a href="http://hc.apache.org/httpcomponents-client">http://hc.apache.org/httpcomponents-client</a>,</p>
<p><a href="http://hc.apache.org/httpcomponents-client">http://hc.apache.org/httpcomponents-client</a>,</p>
<p><a href="http://ws.apache.org/commons/util">http://ws.apache.org/commons/util</a>,</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.checkerframework</p>
</td>
<td width="429">
<p>Copyright &copy; University of Washington PLSE Group.</p>
<p>Licensed under the GNU General Public License, version 2 (GPL2), with the classpath exception The MIT License</p>
<p><a href="http://www.gnu.org/software/classpath/license.html">http://www.gnu.org/software/classpath/license.html</a>.</p>
<p>Licensed under the MIT License</p>
<p><a href="http://opensource.org/licenses/MIT">http://opensource.org/licenses/MIT</a>.</p>
<p>Copyright holder's website: <a href="http://checkerframework.org">http://checkerframework.org</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.codehaus.mojo</p>
</td>
<td width="429">
<p>Copyright &copy; Kohsuke Kaw, Stephen Connolly.</p>
<p>Licensed under the MIT License<a href="http://www.opensource.org/licenses/mit-license.php"><br /> http://www.opensource.org/licenses/mit-license.php</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/mojohaus/animal-sniffer">https://github.com/mojohaus/animal-sniffer</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.codehaus.woodstox</p>
</td>
<td width="429">
<p>Copyright &copy; 2009-2011 FasterXML, LLC.</p>
<p>Licensed under the BSD License<a href="http://www.opensource.org/licenses/bsd-license.php"><br /> http://www.opensource.org/licenses/bsd-license.php</a>.</p>
<p>Copyright holder's website: <a href="http://github.com/FasterXML/stax2-api">http://github.com/FasterXML/stax2-api</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.hamcrest</p>
</td>
<td width="429">
<p>Copyright &copy; 2012-2019&nbsp;Hamcrest.org.</p>
<p>Licensed under the BSD License 3<a href="http://opensource.org/licenses/BSD-3-Clause"><br /> http://opensource.org/licenses/BSD-3-Clause</a>.</p>
<p>Copyright holder's website: <a href="http://hamcrest.org/JavaHamcrest">http://hamcrest.org/JavaHamcrest</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>ws.slink.thirdparty</p>
</td>
<td width="429">
<p>Copyright &copy; 2014-2019 Netflix, Inc.</p>
<p>Developer: Rob Spieldenner.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/nebula-plugins/nebula-release-plugin">https://github.com/nebula-plugins/nebula-release-plugin</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>xml-apis:xml-apis</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="http://xml.apache.org/commons/#external">http://xml.apache.org/commons/#external</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>jakarta.persistence</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation.</p>
<p>Licensed under the Eclipse Distribution License v. 1.0</p>
<p><a href="http://www.eclipse.org/org/documents/edl-v10.php">http://www.eclipse.org/org/documents/edl-v10.php</a>.</p>
<p>Eclipse Public License v. 2.0</p>
<p><a href="http://www.eclipse.org/legal/epl-2.0">http://www.eclipse.org/legal/epl-2.0</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/eclipse-ee4j/jpa-api">https://github.com/eclipse-ee4j/jpa-api</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.checkerframework</p>
</td>
<td width="429">
<p>Copyright &copy; University of Washington PLSE Group.</p>
<p>Licensed under the MIT License<a href="http://opensource.org/licenses/MIT"><br /> http://opensource.org/licenses/MIT</a>.</p>
<p>Copyright holder's website: <a href="https://checkerframework.org">https://checkerframework.org</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.zalando:jackson-datatype-problem</p>
</td>
<td width="429">
<p>Copyright &copy; Zalando SE Developer: Willi Sch&ouml;nborn.</p>
<p>Licensed under the MIT License<a href="https://opensource.org/licenses/MIT"><br /> https://opensource.org/licenses/MIT</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/zalando">https://github.com/zalando</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.jsonwebtoken:jjwt-api</p>
</td>
<td width="429">
<p>Copyright &copy; JJWT Developer: Les Hazlewood.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/jwtk/jjwt">https://github.com/jwtk/jjwt</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.stoyanr:evictor</p>
</td>
<td width="429">
<p>Copyright &copy; Com.stoyanr Group</p>
<p>Developers: Stoyan Rachev,Sandeep Gupta.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/stoyanr/Evictor">https://github.com/stoyanr/Evictor</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>commons-fileupload</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="http://commons.apache.org/proper/commons-fileupload">http://commons.apache.org/proper/commons-fileupload</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.github.openfeign:feign-core</p>
</td>
<td width="429">
<p>Copyright &copy;&nbsp;2023&nbsp;VMware.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/OpenFeign/feign">https://github.com/OpenFeign/feign</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.github.openfeign.form</p>
</td>
<td width="429">
<p>Copyright &copy;&nbsp;Developers: Artem Labazin, Tomasz Juchniewicz,</p>
<p>Guillaume Simard.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/OpenFeign/feign-form">https://github.com/OpenFeign/feign-form</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.projectreactor.addons:reactor-extra</p>
</td>
<td width="429">
<p>Copyright &copy;&nbsp;2021&nbsp;VMware.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's websites: <a href="https://github.com/reactor/reactor-addons">https://github.com/reactor/reactor-addons</a> , <a href="https://projectreactor.io">https://projectreactor.io</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.aspectj:aspectjweaver</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation.</p>
<p>Licensed under the Eclipse Public License, Version 2.0</p>
<p><a href="https://www.eclipse.org/org/documents/epl-2.0/EPL-2.0.txt">https://www.eclipse.org/org/documents/epl-2.0/EPL-2.0.txt</a>.</p>
<p>Copyright holder's website: <a href="https://www.eclipse.org/aspectj">https://www.eclipse.org/aspectj</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.bouncycastle:bcpkix-jdk15on</p>
</td>
<td width="429">
<p>Copyright &copy; 2013 Legion of the Bouncy Castle Inc.&nbsp;</p>
<p>Licensed under the Bouncy Castle Licence<a href="https://www.bouncycastle.org/licence.html"><br /> https://www.bouncycastle.org/licence.html</a>.</p>
<p>Copyright holder's website: <a href="https://www.bouncycastle.org/java.html">https://www.bouncycastle.org/java.html</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.lettuce:lettuce-core</p>
</td>
<td width="429">
<p>Copyright &copy; 2013-2022&nbsp;Lettuce.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: https://lettuce.io,</p>
<p><a href="https://github.com/lettuce-io/lettuce-core">https://github.com/lettuce-io/lettuce-core</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.github.ben-manes.caffeine</p>
</td>
<td width="429">
<p>Copyright &copy; Ben Manes.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/ben-manes/caffeine">https://github.com/ben-manes/caffeine</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.github.virtuald:curvesapi</p>
</td>
<td width="429">
<p>Copyright &copy; Dustin Spicuzza, Stormdollar.</p>
<p>Licensed under the BSD License<a href="http://opensource.org/licenses/BSD-3-Clause"><br /> http://opensource.org/licenses/BSD-3-Clause</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/virtuald/curvesapi">https://github.com/virtuald/curvesapi</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.google.guava:guava</p>
<p>&nbsp;</p>
<p>com.google.inject:guice</p>
</td>
<td width="429">
<p>Copyright &copy; Google LLC.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's websites: <a href="https://github.com/google/guice">https://github.com/google/guice</a> , <a href="https://github.com/google/guava">https://github.com/google/guava</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.netflix.eureka:eureka-client</p>
<p>&nbsp;</p>
<p>com.netflix.netflix-commons:netflix-eventbus</p>
<p>&nbsp;</p>
<p>com.netflix.servo:servo-core</p>
</td>
<td width="429">
<p>Copyright &copy; Netflix Open Source Development.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's websites: https://netflix .github.io,</p>
<p><a href="https://github.com/Netflix/eureka">https://github.com/Netflix/eureka</a>, <a href="https://github.com/Netflix/netflix-commons">https://github.com/Netflix/netflix-commons</a>, <a href="https://github.com/Netflix/servo">https://github.com/Netflix/servo</a>.</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.ongres.scram:client</p>
<p>&nbsp;</p>
<p>com.ongres.stringprep</p>
</td>
<td width="429">
<p>Copyright &copy; 2023 OnGres Inc.</p>
<p>Licensed under the 2-Clause BSD License<a href="https://opensource.org/licenses/BSD-2-Clause"><br /> https://opensource.org/licenses/BSD-2-Clause</a>.</p>
<p>Copyright holder's websites: <a href="https://ongres.com">https://ongres.com</a>,</p>
<p><a href="https://github.com/ongres/stringprep">https://github.com/ongres/stringprep</a>, <a href="https://github.com/ongres/scram">https://github.com/ongres/scram</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.thoughtworks.xstream</p>
</td>
<td width="429">
<p>Copyright &copy; XStream.</p>
<p>Licensed under the BSD-3-Clause</p>
<p><a href="http://x-stream.github.io/license.html">http://x-stream.github.io/license.html</a>.</p>
<p>The copyright holder's website: <a href="http://x-stream.github.io">http://x-stream .github.io</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.zaxxer:HikariCP</p>
</td>
<td width="429">
<p>Copyright &copy; Zaxxer.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>The copyright holder's website: <a href="http://zaxxer.com">http://zaxxer.com</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>commons-configuration:commons-configuration</p>
<p>&nbsp;</p>
<p>commons-io:commons-io</p>
<p>&nbsp;</p>
<p>commons-lang:commons-lang</p>
<p>&nbsp;</p>
<p>commons-beanutils:commons-beanutils</p>
<p>&nbsp;</p>
<p>commons-collections:commons-collections</p>
<p>&nbsp;</p>
<p>commons-logging:commons-logging</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's websites: <a href="http://commons.apache.org/configuration">http://commons.apache.org/configuration</a> , <a href="https://commons.apache.org/proper/commons-io">https://commons.apache.org/proper/commons-io</a> , <a href="https://commons.apache.org/proper/commons-lang">https://commons.apache.org/proper/commons-lang</a> ,</p>
<p><a href="https://commons.apache.org/proper/commons-beanutils">https://commons.apache.org/proper/commons-beanutils</a>,</p>
<p><a href="http://commons.apache.org/collections">http://commons.apache.org/collections</a>,</p>
<p><a href="http://commons.apache.org/proper/commons-logging">http://commons.apache.org/proper/commons-logging</a>.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.github.x-stream:mxparser</p>
</td>
<td width="429">
<p>Copyright &copy; XStream Committers.</p>
<p>Licensed under the Indiana University Extreme! Lab Software License</p>
<p>https://raw.githubusercontent.com/x-stream/mxparser/master/LICENSE.txt.</p>
<p>Copyright holder's website: <a href="https://x-stream.github.io">https://x-stream .github.io</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.projectreactor.addons:reactor-pool</p>
<p>&nbsp;</p>
<p>io.projectreactor.netty</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; 2023&nbsp;VMware.</p>
<p>Licensed under the Apache License, Version 2.0.</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's websites: <a href="https://projectreactor.io">https://projectreactor.io</a>,</p>
<p><a href="https://github.com/reactor/reactor-pool">https://github.com/reactor/reactor-pool</a>, <a href="https://github.com/reactor/reactor-netty">https://github.com/reactor/reactor-netty</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.r2dbc:r2dbc-pool</p>
<p>&nbsp;</p>
<p>io.r2dbc:r2dbc-postgresql</p>
<p>&nbsp;</p>
<p>io.r2dbc:r2dbc-spi</p>
</td>
<td width="429">
<p>Copyright &copy; 2018-2022&nbsp;R2DBC Contributors.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's websites: <a href="https://r2dbc.io">https://r2dbc.io</a>,</p>
<p><a href="https://github.com/r2dbc/r2dbc-pool">https://github.com/r2dbc/r2dbc-pool</a>, <a href="https://github.com/r2dbc/r2dbc-postgresql">https://github.com/r2dbc/r2dbc-postgresql</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.swagger.core.v3:swagger-core</p>
</td>
<td width="429">
<p>Copyright &copy; Francesco Tumanischvili, Tony Tam, Ron Ratovsky.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://mvnrepository.com/artifact/io.swagger.core.v3/swagger-core/2.2.9">https://mvnrepository.com/artifact/io.swagger.core.v3/swagger-core/2.2.9</a> .</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>javax.inject:javax.inject</p>
<p>&nbsp;</p>
<p>javax.ws.rs:jsr311-api</p>
</td>
<td width="429">
<p>Copyright &copy; 2023 Oracle.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website:</p>
<p><a href="https://github.com/javax-inject/javax-inject">https://github.com/javax-inject/javax-inject</a>,</p>
<p><a href="https://jsr311.dev.java.net">https://jsr311.dev.java.net</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.apache.commons:commons-collections</p>
<p>&nbsp;</p>
<p>org.apache.poi</p>
<p>&nbsp;</p>
<p>org.apache.xmlbeans:xmlbeans</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation. Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's websites: <a href="https://commons.apache.org/proper/commons-collections">https://commons.apache.org/proper/commons-collections</a> , <a href="https://poi.apache.org">https://poi.apache.org</a> , <a href="https://xmlbeans.apache.org">https://xmlbeans.apache.org</a>.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.postgresql:postgresql</p>
</td>
<td width="429">
<p>Copyright &copy; 1996-2023 The PostgreSQL Global Development Group.</p>
<p>Licensed under the BSD-2-Clause<a href="https://jdbc.postgresql.org/about/license.html"><br /> https://jdbc.postgresql.org/about/license.html</a>.</p>
<p>Copyright holder's websites: <a href="https://jdbc.postgresql.org">https://jdbc.postgresql.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.springdoc</p>
</td>
<td width="429">
<p>Copyright &copy; 2023 VMware, Inc.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's websites: <a href="https://springdoc.org">https://springdoc.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.webjars:swagger-ui</p>
</td>
<td width="429">
<p>Copyright &copy; James Ward.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's websites: <a href="http://webjars.org">http://webjars.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>xmlpull:xmlpull</p>
</td>
<td width="429">
<p>Copyright &copy; Stefan Haustein, Aleksander Slominski.</p>
<p>Licensed under the Public Domain</p>
<p><a href="http://www.xmlpull.org/v1/download/unpacked/LICENSE.txt">http://www.xmlpull.org/v1/download/unpacked/LICENSE.txt</a>.</p>
<p>Copyright holder's websites: <a href="http://www.xmlpull.org">http://www.xmlpull.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.mysema.commons:mysema-commons-lang</p>
</td>
<td width="429">
<p>Copyright &copy; Mysema Ltd.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's websites: <a href="http://www.mysema.com">http://www.mysema.com</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.querydsl:querydsl-core</p>
</td>
<td width="429">
<p>Copyright &copy; 2007-2020 The Querydsl Team.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's websites: <a href="http://querydsl.com">http://querydsl.com</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.sun.istack:istack-commons-runtime</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation.</p>
<p>Licensed under the Eclipse Distribution License, Version 1.0<a href="http://www.eclipse.org/org/documents/edl-v10.php"><br /> http://www.eclipse.org/org/documents/edl-v10.php</a></p>
<p>Copyright holder's website: <a href="https://projects.eclipse.org/projects/ee4j/istack-commons-runtime">https://projects.eclipse.org/projects/ee4j/istack-commons-runtime</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>jakarta.transaction:jakarta.transaction-api</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation.</p>
<p>Licensed under the EPL 2.0</p>
<p><a href="http://www.eclipse.org/legal/epl-2.0">http://www.eclipse.org/legal/epl-2.0</a>.</p>
<p>Licensed under the GPL2 w/CPE<a href="https://www.gnu.org/software/classpath/license.html"><br /> https://www.gnu.org/software/classpath/license.html</a>.</p>
<p>Copyright holder's website: <a href="https://projects.eclipse.org/projects/ee4j.jta">https://projects.eclipse.org/projects/ee4j.jta</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.glassfish.jaxb:jaxb-runtime</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation.</p>
<p>Licensed under the Eclipse Distribution License, Version 1.0</p>
<p><a href="http://www.eclipse.org/org/documents/edl-v10.php">http://www.eclipse.org/org/documents/edl-v10.php</a>.</p>
<p>Copyright holder's website: <a href="https://eclipse-ee4j.github.io/jaxb-ri">https://eclipse-ee4j.github.io/jaxb-ri</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.hibernate:hibernate-core</p>
<p>&nbsp;</p>
<p>org.hibernate.common:hibernate-commons-annotations</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; Red Hat, Inc.</p>
<p>Licensed under the GNU Library General Public License v2.1 or later<a href="https://www.opensource.org/licenses/LGPL-2.1"><br /> https://www.opensource.org/licenses/LGPL-2.1</a>.</p>
<p>Copyright holder's website: <a href="https://hibernate.org">https://hibernate.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.jboss:jandex</p>
</td>
<td width="429">
<p>Copyright &copy; JBoss.org Community by Red Hat, Inc.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://www.jboss.org">https://www.jboss.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.sun.mail:jakarta.mail</p>
</td>
<td width="429">
<p>Copyright &copy; Bill Shannon (Oracle),Eclipse EE4J Developers.</p>
<p>Licensed under the EDL 1.0</p>
<p><a href="http://www.eclipse.org/org/documents/edl-v10.php">http://www.eclipse.org/org/documents/edl-v10.php</a>.</p>
<p>Licensed under the EPL 2.0</p>
<p><a href="http://www.eclipse.org/legal/epl-2.0">http://www.eclipse.org/legal/epl-2.0</a>.</p>
<p>Licensed under the GPL2 w/CPE</p>
<p><a href="https://www.gnu.org/software/classpath/license.html">https://www.gnu.org/software/classpath/license.html</a>.</p>
<p>Copyright holder's website: <a href="https://mvnrepository.com/artifact/com.sun.mail/jakarta.mail/1.6.7">https://mvnrepository.com/artifact/com.sun.mail/jakarta.mail/1.6.7</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.attoparser:attoparser</p>
</td>
<td width="429">
<p>Copyright &copy; The&nbsp;ATTOPARSER Team.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://www.attoparser.org">https://www.attoparser.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.thymeleaf:thymeleaf</p>
<p>&nbsp;</p>
<p>org.thymeleaf.extras:thymeleaf-extras-java8time</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; The Thymeleaf Team.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="http://www.thymeleaf.org">http://www.thymeleaf.org</a>.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.unbescape:unbescape</p>
</td>
<td width="429">
<p>Copyright &copy; The&nbsp;UNBESCAPE Team.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://www.unbescape.org">https://www.unbescape.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.opencsv:opencsv</p>
</td>
<td width="429">
<p>Copyright &copy; Com.opencsv Group.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://opencsv.sourceforge.net">https://opencsv.sourceforge.net</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.zipkin.aws:brave-propagation-aws</p>
<p>&nbsp;</p>
<p>io.zipkin.brave</p>
<p>&nbsp;</p>
<p>io.zipkin.reporter2</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; Com.opencsv Group.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://zipkin.io">https://zipkin.io</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.apache.commons:commons-text</p>
<p>&nbsp;</p>
<p>org.apache.sshd:sshd-common</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation. Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's websites: <a href="https://commons.apache.org/proper/commons-text">https://commons.apache.org/proper/commons-text</a>,</p>
<p><a href="https://github.com/apache/mina-sshd">https://github.com/apache/mina-sshd</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.aspectj:aspectjrt</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation.</p>
<p>Licensed under the Eclipse Distribution License, Version 2.0</p>
<p><a href="https://www.eclipse.org/org/documents/epl-2.0/EPL-2.0.txt">https://www.eclipse.org/org/documents/epl-2.0/EPL-2.0.txt</a>.</p>
<p>Copyright holder's website: <a href="https://www.eclipse.org/aspectj">https://www.eclipse.org/aspectj</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.fasterxml.jackson.core</p>
</td>
<td width="429">
<p>Copyright &copy; 2009-2011 FasterXML, LLC.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/FasterXML/jackson">https://github.com/FasterXML/jackson</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.googlecode.javaewah</p>
</td>
<td width="429">
<p>Copyright &copy; LICEF Research Center.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/lemire/javaewah">https://github.com/lemire/javaewah</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>net.i2p.crypto:eddsa</p>
</td>
<td width="429">
<p>Copyright &copy; Net.i2p.crypto Group.</p>
<p>Licensed under the CC0 1.0 Universal</p>
<p><a href="https://creativecommons.org/publicdomain/zero/1.0/">https://creativecommons.org/publicdomain/zero/1.0</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/str4d/ed25519-java">https://github.com/str4d/ed25519-java</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.eclipse.jgit:org.eclipse.jgit</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation.</p>
<p>Licensed under the Eclipse Distribution License (New BSD License).</p>
<p><a href="https://www.eclipse.org/org/documents/edl-v10.php">https://www.eclipse.org/org/documents/edl-v10.php</a>.</p>
<p>Copyright holder's website: <a href="https://www.eclipse.org/jgit">https://www.eclipse.org/jgit</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.undertow:undertow-core</p>
<p>&nbsp;</p>
<p>io.undertow:undertow-servlet</p>
<p>&nbsp;</p>
<p>io.undertow:undertow-websockets-jsr</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; JBoss.org Community by Red Hat, Inc.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://www.jboss.org">https://www.jboss.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>jakarta.websocket:jakarta.websocket-api</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation.</p>
<p>Licensed under the GNU General Public License 2.0 with the GNU Classpath Exception.</p>
<p><a href="https://projects.eclipse.org/license/secondary-gpl-2.0-cp">https://projects.eclipse.org/license/secondary-gpl-2.0-cp</a>.</p>
<p>Licensed under the Eclipse Public License 2.0<a href="https://projects.eclipse.org/license/epl-2.0"><br /> https://projects.eclipse.org/license/epl-2.0</a>.</p>
<p>Copyright holder's website: <a href="https://projects.eclipse.org/projects/ee4j.websocket">https://projects.eclipse.org/projects/ee4j.websocket</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.jboss.threads:jboss-threads</p>
<p>&nbsp;</p>
<p>org.jboss.xnio</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; JBoss.org Community by Red Hat, Inc.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="http://www.jboss.org">http://www.jboss.org</a>, <a href="http://www.jboss.org/xnio">http://www.jboss.org/xnio</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.wildfly.client</p>
<p>&nbsp;</p>
<p>org.wildfly.common</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; JBoss.org Community by Red Hat, Inc.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="http://www.jboss.org">http://www.jboss.org</a>.</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.fasterxml.jackson.dataformat</p>
</td>
<td width="429">
<p>Copyright &copy; 2009-2011 FasterXML, LLC.</p>
<p>Developer: Tatu Saloranta.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/FasterXML/jackson-dataformat-xml">https://github.com/FasterXML/jackson-dataformat-xml</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.sun.jersey</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation.</p>
<p>Licensed under the CDDL 1.1<a href="http://glassfish.java.net/public/CDDL+GPL_1_1.html"><br /> http://glassfish.java.net/public/CDDL+GPL_1_1.html</a>.</p>
<p>Licensed under the GPL2 w/CPE</p>
<p><a href="http://glassfish.java.net/public/CDDL+GPL_1_1.html">http://glassfish.java.net/public/CDDL+GPL_1_1.html</a>.</p>
<p>Copyright holder's website: <a href="https://jersey.java.net/jersey-client">https://jersey.java.net/jersey-client</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.freemarker</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation. Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://freemarker.apache.org">https://freemarker.apache.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.vladmihalcea</p>
</td>
<td width="429">
<p>Copyright &copy; 2017-2020 Mihalcea Vlad-Alexandru.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/vladmihalcea/hypersistence-utils">https://github.com/vladmihalcea/hypersistence-utils</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.cache2k:cache2k-api</p>
</td>
<td width="429">
<p>Copyright &copy; Headissue GmbH.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://www.headissue.com">https://www.headissue.com</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.hibernate:hibernate-jcache</p>
</td>
<td width="429">
<p>Copyright &copy; Red Hat, Inc.</p>
<p>Licensed under the GNU Library General Public License v2.1 or later<a href="https://www.opensource.org/licenses/LGPL-2.1"><br /> https://www.opensource.org/licenses/LGPL-2.1</a>.</p>
<p>Copyright holder's website: <a href="https://hibernate.org">https://hibernate.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.redisson</p>
</td>
<td width="429">
<p>Copyright &copy; Redisson.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Copyright holder's website: <a href="https://redisson.org">https://redisson.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.hypersistence</p>
</td>
<td width="429">
<p>Copyright &copy; 2020-2022 Fabio Lima.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/vladmihalcea/hypersistence-tsid/blob/master/LICENSE">https://github.com/vladmihalcea/hypersistence-tsid/blob/master/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/vladmihalcea/hypersistence-tsid">https://github.com/vladmihalcea/hypersistence-tsid</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.github.mwiede</p>
</td>
<td width="429">
<p>Copyright &copy; Com.github.mwiede Group.</p>
<p>Licensed under the Revised BSD</p>
<p><a href="https://github.com/mwiede/jsch/blob/master/LICENSE.txt">https://github.com/mwiede/jsch/blob/master/LICENSE.txt</a></p>
<p>Licensed under the ISC</p>
<p>https://github.com/mwiede/jsch/blob/master/LICENSE.jBCrypt.txt</p>
<p>Licensed under the BSD</p>
<p><a href="https://github.com/mwiede/jsch/blob/master/LICENSE.JZlib.txt">https://github.com/mwiede/jsch/blob/master/LICENSE.JZlib.txt</a></p>
<p>Copyright holder's website: <a href="https://github.com/mwiede/jsch">https://github.com/mwiede/jsch</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>commons-net:commons-net</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation. Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.txt">https://www.apache.org/licenses/LICENSE-2.0.txt</a>.</p>
<p>Copyright holder's website: <a href="https://commons.apache.org/proper/commons-net">https://commons.apache.org/proper/commons-net</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>javax.annotation:javax.annotation-api</p>
</td>
<td width="429">
<p>Copyright &copy; GlassFish Community.</p>
<p>Licensed under the CDDL + GPLv2 with classpath exception</p>
<p><a href="https://github.com/javaee/javax.annotation/blob/master/LICENSE">https://github.com/javaee/javax.annotation/blob/master/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://jcp.org/en/jsr/detail?id=250">https://jcp.org/en/jsr/detail?id=250</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.sun.xml.bind:jaxb-core</p>
</td>
<td width="429">
<p>Copyright &copy; Oracle Corporation.</p>
<p>Licensed under the CDDL</p>
<p><a href="https://oss.oracle.com/licenses/CDDL+GPL-1.1">https://oss.oracle.com/licenses/CDDL+GPL-1.1</a>.</p>
<p>Licensed under the GPL License</p>
<p><a href="https://oss.oracle.com/licenses/CDDL+GPL-1.1">https://oss.oracle.com/licenses/CDDL+GPL-1.1</a>.</p>
<p>Copyright holder's website: <a href="https://mvnrepository.com/artifact/javax.xml.bind/jaxb-api/2.4/0-b180830.0359">https://mvnrepository.com/artifact/javax.xml.bind/jaxb-api/2.4/0-b180830.0359</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.apache.camel</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://github.com/apache/camel/blob/main/LICENSE.txt/">https://github.com/apache/camel/blob/main/LICENSE.txt</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/apache/camel">https://github.com/apache/camel</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p><strong>Intellectual property of third parties of the software web interface</strong></p>
<table width="662">
<thead>
<tr>
<td width="243">
<p><strong>Name of the intellectual property</strong></p>
</td>
<td width="419">
<p><strong>Notification</strong></p>
</td>
</tr>
</thead>
<tbody>
<tr>
<td width="243">
<p>novnc/novnc</p>
</td>
<td width="419">
<p>Copyright &copy; 2022 The noVNC Authors.</p>
<p>Licensed under the MPL 2.0 (Mozilla</p>
<p>Public License 2.0)</p>
<p><a href="http://www.mozilla.org/MPL/2.0">http://www.mozilla.org/MPL/2.0</a>.</p>
<p>Licensed under the BSD licenses</p>
<p><a href="http://en.wikipedia.org/wiki/BSD_licenses">http://en.wikipedia.org/wiki/BSD_licenses</a>.</p>
<p>Licensed under the MIT licenses</p>
<p>https://opensource.org/licenses/MIT.</p>
<p>Copyright holder's websites: <a href="https://novnc.com">https://novnc.com</a>,</p>
<p><a href="https://github.com/novnc/noVNC">https://github.com/novnc/noVNC</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>spice-project/spice-html5</p>
</td>
<td width="419">
<p>Copyright &copy; 2007 Free Software Foundation, SPICE project.</p>
<p>Licensed under the GNU GENERAL PUBLIC LICENSE</p>
<p>https://github.com/jloboescalona2/spice-html5/blob/master/COPYING.</p>
<p>Copyright holder's websites:</p>
<p><a href="https://www.spice-space.org">https://www.spice-space.org</a>,</p>
<p><a href="https://gitlab.freedesktop.org/spice/spice-html5">https://gitlab.freedesktop.org/spice/spice-html5</a>.</p>
</td>
</tr>
<tr>
<td width="243">
<p>vue/composition-api</p>
</td>
<td width="419">
<p>Copyright &copy; 2019 liximomo (X.L).</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/vuejs/composition-api/blob/main/LICENSE">https://github.com/vuejs/composition-api/blob/main/LICENSE</a>.</p>
<p>Copyright holder's website:</p>
<p><a href="https://github.com/vuejs/composition-api">https://github.com/vuejs/composition-api</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>ansi-styles</p>
</td>
<td width="419">
<p>Copyright &copy; Sindre Sorhus.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://spdx.org/licenses/MIT#licenseText">https://spdx.org/licenses/MIT#licenseText</a></p>
<p>Copyright holder's websites: <a href="https://www.webjars.org">https://www.webjars.org</a>,</p>
<p><a href="https://sindresorhus.com">https://sindresorhus.com</a>.</p>
<p><strong>&nbsp;</strong></p>
</td>
</tr>
<tr>
<td width="243">
<p>apexcharts</p>
</td>
<td width="419">
<p>Copyright &copy; 2018 ApexCharts.</p>
<p>Licensed under the MIT License https://github.com/apexcharts/apexcharts.js/blob/main/LICENSE.</p>
<p>Copyright holder's websites:</p>
<p><a href="https://apexcharts.com">https://apexcharts.com</a>,</p>
<p><a href="https://github.com/apexcharts/apexcharts.js">https://github.com/apexcharts/apexcharts.js</a>.</p>
<p><strong>&nbsp;</strong></p>
</td>
</tr>
<tr>
<td width="243">
<p>argparse</p>
</td>
<td width="419">
<p>Copyright &copy; 1991 - 1995 Stichting Mathematisch Centrum, Amsterdam. The Netherlands.</p>
<p>Licensed under the GPL License</p>
<p><a href="https://unpkg.com/argparse@2.0.1/LICENSE">https://unpkg.com/argparse@2.0.1/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/nodeca.">https://github.com/nodeca.</a></p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>axios</p>
</td>
<td width="419">
<p>Copyright &copy; 2014-present Matt Zabriskie &amp; Collaborators.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/axios/axios/blob/v1.x/LICENSE">https://github.com/axios/axios/blob/v1.x/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/axios/axios">https://github.com/axios/axios</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>chalk</p>
</td>
<td width="419">
<p>Copyright &copy; Sindre Sorhus.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://wave.germanywestcentral.cloudapp.azure.com/licenses/chalk%402.4.2">https://wave.germanywestcentral.cloudapp.azure.com/licenses/chalk%402.4.2</a></p>
<p>Copyright holder's website: <a href="https://sindresorhus.com">https://sindresorhus.com</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>clone</p>
</td>
<td width="419">
<p>Copyright &copy; 2011-2015 Paul Vorbach.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/pvorb/clone/blob/master/LICENSE">https://github.com/pvorb/clone/blob/master/LICENSE</a></p>
<p>Copyright holder's website: <a href="https://github.com/pvorb/clone">https://github.com/pvorb/clone</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>color-convert</p>
</td>
<td width="419">
<p>Copyright &copy; 2011-2016 Heather Arthur, 2016-2021 Josh Junon.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://wave.germanywestcentral.cloudapp.azure.com/licenses/color-convert%401.9.3">https://wave.germanywestcentral.cloudapp.azure.com/licenses/color-convert%401.9.3</a></p>
<p>Copyright holder's website: <a href="https://github.com/Qix-/color-convert">https://github.com/Qix-/color-convert</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>color-name</p>
</td>
<td width="419">
<p>Copyright &copy; 2015 Dmitry Ivanov.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/colorjs/color-name/blob/master/LICENSE">https://github.com/colorjs/color-name/blob/master/LICENSE</a></p>
<p>Copyright holder's website: <a href="https://github.com/colorjs/color-name">https://github.com/colorjs/color-name</a>.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>core-js</p>
</td>
<td width="419">
<p>Copyright &copy; 2014-2023 Denis Pushkarev.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/zloirock/core-js/blob/master/LICENSE">https://github.com/zloirock/core-js/blob/master/LICENSE</a></p>
<p>Copyright holder's website: <a href="https://github.com/zloirock/core-js">https://github.com/zloirock/core-js</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>debug</p>
</td>
<td width="419">
<p>Copyright &copy; Debug Group.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/aDotInTheVoid/debug3/blob/trunk/LICENSE-MIT.">https://github.com/aDotInTheVoid/debug3/blob/trunk/LICENSE-MIT.</a></p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://github.com/apache/camel/blob/main/LICENSE.txt/">https://github.com/apache/camel/blob/main/LICENSE.txt</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/aDotInTheVoid/debug3">https://github.com/aDotInTheVoid/debug3</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>deepmerge</p>
</td>
<td width="419">
<p>Copyright &copy; 2012 James Halliday, Josh Duff, and other contributors.</p>
<p>Licensed under the MIT License <a href="https://github.com/TehShrike/deepmerge/blob/master/license.txt">https://github.com/TehShrike/deepmerge/blob/master/license.txt</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/TehShrike/deepmerge">https://github.com/TehShrike/deepmerge</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>dom-serializer</p>
</td>
<td width="419">
<p>Copyright &copy; 2022 The Cheerio contributors.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/cheeriojs/dom-serializer/blob/master/LICENSE">https://github.com/cheeriojs/dom-serializer/blob/master/LICENSE</a></p>
<p>Copyright holder's website: <a href="https://github.com/cheeriojs/dom-serializer">https://github.com/cheeriojs/dom-serializer</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>domelementtype</p>
</td>
<td width="419">
<p>Copyright &copy; Felix B&ouml;hm.</p>
<p>Licensed under the BSD 2-Clause License</p>
<p><a href="https://github.com/fb55/domelementtype/blob/master/LICENSE">https://github.com/fb55/domelementtype/blob/master/LICENSE</a></p>
<p>Copyright holder's website: <a href="https://github.com/fb55/domelementtype">https://github.com/fb55/domelementtype</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>domhandler</p>
</td>
<td width="419">
<p>Copyright &copy; Felix B&ouml;hm.</p>
<p>Licensed under the BSD 2-Clause License</p>
<p><a href="https://github.com/fb55/domhandler/blob/master/LICENSE">https://github.com/fb55/domhandler/blob/master/LICENSE</a></p>
<p>Copyright holder's website: <a href="https://github.com/fb55/DomHandler">https://github.com/fb55/DomHandler</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>domutils</p>
</td>
<td width="419">
<p>Copyright &copy; Felix B&ouml;hm.</p>
<p>Licensed under the BSD 2-Clause License</p>
<p><a href="https://github.com/fb55/domutils/blob/master/LICENSE">https://github.com/fb55/domutils/blob/master/LICENSE</a></p>
<p>Copyright holder's website: <a href="https://github.com/fb55/domutils">https://github.com/fb55/domutils</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>draggable-vue-directive</p>
</td>
<td width="419">
<p>Copyright &copy; 2018 Israel Zablianov.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/IsraelZablianov/draggable-vue-directive/blob/master/LICENSE.md">https://github.com/IsraelZablianov/draggable-vue-directive/blob/master/LICENSE.md</a></p>
<p>Copyright holder's website: <a href="https://github.com/IsraelZablianov/draggable-vue-directive/tree/master">https://github.com/IsraelZablianov/draggable-vue-directive/tree/master</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>entities</p>
</td>
<td width="419">
<p>Copyright &copy; Felix B&ouml;hm.</p>
<p>Licensed under the BSD 2-Clause License</p>
<p><a href="https://github.com/fb55/entities/blob/master/LICENSE">https://github.com/fb55/entities/blob/master/LICENSE</a></p>
<p>Copyright holder's website: <a href="https://github.com/fb55/entities">https://github.com/fb55/entities</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>escape-string-regexp</p>
</td>
<td width="419">
<p>Copyright &copy; Sindre Sorhus.</p>
<p>Licensed under the MIT License</p>
<p>https://github.com/sindresorhus/escape-string-regexp/blob/main/license</p>
<p>Copyright holder's website: <a href="https://sindresorhus.com">https://sindresorhus.com</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>event-source-polyfill</p>
<p>&nbsp;</p>
</td>
<td width="419">
<p>Copyright &copy; 2012 <a href="mailto:vic99999@yandex.ru">vic99999@yandex.ru</a>, 2018 Viktor.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/Yaffle/EventSource/blob/master/LICENSE">https://github.com/Yaffle/EventSource/blob/master/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/Yaffle/EventSource">https://github.com/Yaffle/EventSource</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>follow-redirects</p>
</td>
<td width="419">
<p>Copyright &copy; 2014 Olivier Lalonde, James Talmage, Ruben Verborgh.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/follow-redirects/follow-redirects/blob/main/LICENSE">https://github.com/follow-redirects/follow-redirects/blob/main/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/Yaffle/EventSource">https://github.com/Yaffle/EventSource</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>Frontend</p>
</td>
<td width="419">
<p>Copyright &copy; 2007 Free Software Foundation, Inc.</p>
<p>Licensed under the GNU AFFERO GENERAL PUBLIC LICENSE</p>
<p><a href="https://github.com/edx-unsupported/frontend-base/blob/master/LICENSE">https://github.com/edx-unsupported/frontend-base/blob/master/LICENSE</a></p>
<p>Copyright holder's website: <a href="http://fsf.org">http://fsf.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>guacamole-common-js</p>
</td>
<td width="419">
<p>Copyright &copy; 2011, Duo Security, Inc.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.txt">https://www.apache.org/licenses/LICENSE-2.0.txt</a>.</p>
<p>Copyright holder's website: <a href="https://guacamole.apache.org">https://guacamole.apache.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>has-flag</p>
</td>
<td width="419">
<p>Copyright &copy; Sindre Sorhus.</p>
<p>Licensed under the MIT License</p>
<p>https://wave.germanywestcentral.cloudapp.azure.com/licenses/has-flag%403.0.0</p>
<p>Copyright holder's website: <a href="https://github.com/sindresorhus/has-flag">https://github.com/sindresorhus/has-flag</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>htmlparser2</p>
</td>
<td width="419">
<p>Copyright &copy; 2010, 2011 Chris Winberry.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/fb55/htmlparser2/blob/master/LICENSE">https://github.com/fb55/htmlparser2/blob/master/LICENSE</a></p>
<p>Copyright holder's website: <a href="https://github.com/fb55/htmlparser2/tree/master">https://github.com/fb55/htmlparser2/tree/master</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>inherits</p>
</td>
<td width="419">
<p>Copyright &copy; 2011-2023 Isaac Z. Schlueter.</p>
<p>Licensed under the ISC License</p>
<p><a href="https://wave.germanywestcentral.cloudapp.azure.com/licenses/inherits%402.0.4">https://wave.germanywestcentral.cloudapp.azure.com/licenses/inherits%402.0.4</a></p>
<p>Copyright holder's website: <a href="https://github.com/isaacs/inherits/tree/main">https://github.com/isaacs/inherits/tree/main</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>js-file-download</p>
</td>
<td width="419">
<p>Copyright &copy; 2017 Kenneth Jiang.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/kennethjiang/js-file-download/blob/master/LICENSE">https://github.com/kennethjiang/js-file-download/blob/master/LICENSE</a></p>
<p>Copyright holder's website: <a href="https://github.com/kennethjiang/js-file-download">https://github.com/kennethjiang/js-file-download</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>jwt-decode</p>
</td>
<td width="419">
<p>Copyright &copy; 2017 Kenneth Jiang.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/kennethjiang/js-file-download/blob/master/LICENSE">https://github.com/kennethjiang/js-file-download/blob/master/LICENSE</a></p>
<p>Copyright holder's website: <a href="https://github.com/kennethjiang/js-file-download">https://github.com/kennethjiang/js-file-download</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>jwt-decode</p>
</td>
<td width="419">
<p>Copyright &copy; 2015 Auth0, Inc.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/auth0/jwt-decode/blob/main/LICENSE%20">https://github.com/auth0/jwt-decode/blob/main/LICENSE </a></p>
<p>Copyright holder's website: <a href="http://auth0.com">http://auth0.com</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>linkify-it</p>
</td>
<td width="419">
<p>Copyright &copy; 2015 Vitaly Puzrin.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/markdown-it/linkify-it/blob/master/LICENSE">https://github.com/markdown-it/linkify-it/blob/master/LICENSE</a></p>
<p>Copyright holder's website: <a href="https://github.com/markdown-it/linkify-it/tree/master">https://github.com/markdown-it/linkify-it/tree/master</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>lodash</p>
</td>
<td width="419">Copyright &copy; 2015 Jeremy Ashkenas.
<p>Licensed under the MIT License</p>
<p><a href="https://raw.githubusercontent.com/lodash/lodash/4.17.15-npm/LICENSE">https://raw.githubusercontent.com/lodash/lodash/4.17.15-npm/LICENSE</a></p>
<p>Copyright holder's website: <a href="https://mvnrepository.com/artifact/org.webjars.npm/lodash/4.17.15">https://mvnrepository.com/artifact/org.webjars.npm/lodash/4.17.15</a></p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>lodash.clonedeep</p>
</td>
<td width="419">Copyright &copy; JS Foundation and other contributors.
<p>Licensed under the MIT License</p>
<p><a href="https://raw.githubusercontent.com/lodash/lodash/4.17.15-npm/LICENSE">https://raw.githubusercontent.com/lodash/lodash/4.17.15-npm/LICENSE</a></p>
<p>Copyright holder's websites: <a href="https://js.foundation">https://js.foundation</a>,</p>
<p><a href="https://github.com/lodash/lodash">https://github.com/lodash/lodash</a></p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>markdown-it</p>
</td>
<td width="419">Copyright &copy; 2014 Vitaly Puzrin, Alex Kocharin.
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/markdown-it/markdown-it/blob/master/LICENSE">https://github.com/markdown-it/markdown-it/blob/master/LICENSE</a></p>
<p>Copyright holder's website: <a href="https://github.com/markdown-it/markdown-it/tree/master">https://github.com/markdown-it/markdown-it/tree/master</a></p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>mdurl</p>
</td>
<td width="419">Copyright &copy; 2015 Vitaly Puzrin, Alex Kocharin.
<p>Licensed under the MIT License</p>
<p>https://github.com/markdown-it/mdurl/blob/master/LICENSE.</p>
<p>Copyright holder's website: <a href="https://github.com/markdown-it/mdurl">https://github.com/markdown-it/mdurl</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>moment</p>
<p>&nbsp;</p>
<p>moment-timezone</p>
</td>
<td width="419">Copyright &copy; JS Foundation and other contributors.
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/moment/moment/blob/develop/LICENSE">https://github.com/moment/moment/blob/develop/LICENSE</a>.</p>
<p>Copyright holder's websites: <a href="https://momentjs.com">https://momentjs.com</a>.</p>
<p><a href="https://github.com/moment/moment-timezone">https://github.com/moment/moment-timezone</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>ms (axios)</p>
</td>
<td width="419">Copyright &copy; 2014-present Matt Zabriskie &amp; Collaborator.
<p>Licensed under the MIT License</p>
<a href="https://github.com/axios/axios/blob/v1.x/LICENSE">https://github.com/axios/axios/blob/v1.x/LICENSE</a>.Copyright holder's websites: <a href="https://github.com/axios/axios">https://github.com/axios/axios</a>.&nbsp;</td>
</tr>
<tr>
<td width="243">
<p>parse-srcset</p>
</td>
<td width="419">Copyright &copy; 2014 Alex Bell.
<p>Licensed under the MIT License</p>
<p>https://github.com/albell/parse-srcset/blob/master/LICENSE.</p>
<p>Copyright holder's website: <a href="https://github.com/albell/parse-srcset">https://github.com/albell/parse-srcset</a>.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>postcss</p>
</td>
<td width="419">Copyright &copy; 2013 Andrey Sitnik.
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/postcss/postcss/blob/main/LICENSE">https://github.com/postcss/postcss/blob/main/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/postcss/postcss/tree/main">https://github.com/postcss/postcss/tree/main</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>posthtml</p>
</td>
<td width="419">
<p>Copyright &copy; 2015 PostHTML.</p>
<p>Licensed under the MIT License.</p>
<p>https://github.com/posthtml/posthtml/blob/master/license.</p>
<p>Copyright holder's website: <a href="https://github.com/posthtml/posthtml">https://github.com/posthtml/posthtml</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>posthtml-match-helper</p>
</td>
<td width="419">
<p>Copyright &copy; 2015 PostHTML.</p>
<p>Licensed under the ISC License.</p>
<p>https://spdx.org/licenses/ISC.html</p>
<p>Copyright holder's website: <a href="https://github.com/posthtml/posthtml-match-helper">https://github.com/posthtml/posthtml-match-helper</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>posthtml-match-helper</p>
</td>
<td width="419">
<p>Copyright &copy; 2015 Ivan Voischev.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/posthtml/posthtml-parser/blob/master/license">https://github.com/posthtml/posthtml-parser/blob/master/license</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/posthtml/posthtml-parser">https://github.com/posthtml/posthtml-parser</a></p>
&nbsp;</td>
</tr>
<tr>
<td width="243">
<p>posthtml-render</p>
</td>
<td width="419">
<p>Copyright &copy; 2017 Ivan Voischev.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/posthtml/posthtml-render/blob/master/license">https://github.com/posthtml/posthtml-render/blob/master/license</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/posthtml/posthtml-render">https://github.com/posthtml/posthtml-render</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>postsvg</p>
</td>
<td width="419">
<p>Copyright &copy; 2018 JetBrains s.r.o.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/JetBrains/svg-mixer/blob/master/LICENSE">https://github.com/JetBrains/svg-mixer/blob/master/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/JetBrains/svg-mixer">https://github.com/JetBrains/svg-mixer</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>qs</p>
</td>
<td width="419">
<p>Copyright &copy; 2014 Nathan LaFreniere and other&nbsp;<a href="https://github.com/ljharb/qs/graphs/contributors">contributors</a>.</p>
<p>Licensed under the BSD 3-Clause License.</p>
<p><a href="https://github.com/ljharb/qs/blob/main/LICENSE.md">https://github.com/ljharb/qs/blob/main/LICENSE.md</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/ljharb/qs">https://github.com/ljharb/qs</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>readable-stream</p>
</td>
<td width="419">
<p>Copyright &copy; Node.js contributors.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://wave.germanywestcentral.cloudapp.azure.com/licenses/readable-stream%403.6.0">https://wave.germanywestcentral.cloudapp.azure.com/licenses/readable-stream%403.6.0</a></p>
<p>Copyright holder's website: <a href="https://github.com/nodejs/readable-stream">https://github.com/nodejs/readable-stream</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>safe-buffer</p>
</td>
<td width="419">
<p>Copyright &copy; Feross Aboukhadijeh.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/feross/safe-buffer/blob/master/LICENSE">https://github.com/feross/safe-buffer/blob/master/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/feross/safe-buffer">https://github.com/feross/safe-buffer</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>sanitize-html</p>
</td>
<td width="419">
<p>Copyright &copy; 2013, 2014, 2015 P'unk Avenue LLC.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/apostrophecms/sanitize-html/blob/main/LICENSE/">https://github.com/apostrophecms/sanitize-html/blob/main/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/apostrophecms/sanitize-html">https://github.com/apostrophecms/sanitize-html</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>Sortablejs</p>
</td>
<td width="419">
<p>Copyright &copy; 2019 All contributors to Sortable.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/SortableJS/Sortable/blob/master/LICENSE">https://github.com/SortableJS/Sortable/blob/master/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://sortablejs.github.io/Sortable">https://sortablejs.github.io/Sortable</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>source-map</p>
</td>
<td width="419">
<p>Copyright &copy; 2009-2011, Mozilla Foundation and contributors.</p>
<p>Licensed under the BSD 3-Clause License.</p>
<p><a href="https://github.com/7rulnik/source-map-js/blob/patch-0.6.1/LICENSE">https://github.com/7rulnik/source-map-js/blob/patch-0.6.1/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/7rulnik/source-map-js/tree/patch-0.6.1">https://github.com/7rulnik/source-map-js/tree/patch-0.6.1</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>string_decoder</p>
</td>
<td width="419">
<p>Copyright &copy; Node.js contributors.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/nodejs/string_decoder/blob/main/LICENSE">https://github.com/nodejs/string_decoder/blob/main/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/nodejs/string_decoder">https://github.com/nodejs/string_decoder</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>supports-color</p>
</td>
<td width="419">
<p>Copyright &copy; Sindre Sorhus.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/chalk/supports-color/blob/main/license">https://github.com/chalk/supports-color/blob/main/license</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/chalk/supports-color/tree/main">https://github.com/chalk/supports-color/tree/main</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>svg.draggable.js</p>
</td>
<td width="419">
<p>Copyright &copy; 2018 Ulrich-Matthias.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/svgdotjs/svg.draggable.js/blob/master/LICENSE">https://github.com/svgdotjs/svg.draggable.js/blob/master/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/svgdotjs/svg.draggable.js">https://github.com/svgdotjs/svg.draggable.js</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>svg.easing.js</p>
</td>
<td width="419">
<p>Copyright &copy; 2014 Fuzzy.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/svgdotjs/svg.easing.js/blob/master/LICENSE">https://github.com/svgdotjs/svg.easing.js/blob/master/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/svgdotjs/svg.easing.js">https://github.com/svgdotjs/svg.easing.js</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>svg.filter.js</p>
</td>
<td width="419">
<p>Copyright &copy; 2018 Wout Fierens.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/svgdotjs/svg.filter.js/blob/master/LICENSE">https://github.com/svgdotjs/svg.filter.js/blob/master/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/svgdotjs/svg.filter.js">https://github.com/svgdotjs/svg.filter.js</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>svg.js</p>
</td>
<td width="419">
<p>Copyright &copy; 2012-2018 Wout Fierens.</p>
<p>Licensed under the MIT License.</p>
<p>https://github.com/svgdotjs/svg.js/blob/master/LICENSE.txt.</p>
<p>Copyright holder's websites: <a href="https://svgdotjs.github.io">https://svgdotjs.github.io</a>,</p>
<p><a href="https://github.com/svgdotjs/svg.js">https://github.com/svgdotjs/svg.js</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>svg.pathmorphing.js</p>
</td>
<td width="419">
<p>Copyright &copy; 2014 Fuzzy.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/svgdotjs/svg.pathmorphing.js/blob/master/LICENSE">https://github.com/svgdotjs/svg.pathmorphing.js/blob/master/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/svgdotjs/svg.pathmorphing.js">https://github.com/svgdotjs/svg.pathmorphing.js</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>svg.resize.js</p>
</td>
<td width="419">
<p>Copyright &copy; 2017 Ulrich-Matthias Sch&auml;fer.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/svgdotjs/svg.resize.js/blob/master/LICENSE">https://github.com/svgdotjs/svg.resize.js/blob/master/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/svgdotjs/svg.resize.js">https://github.com/svgdotjs/svg.resize.js</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>uc.micro</p>
<p>&nbsp;</p>
</td>
<td width="419">
<p>Copyright &copy; Mathias Bynens.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/markdown-it/uc.micro/blob/master/LICENSE.txt">https://github.com/markdown-it/uc.micro/blob/master/LICENSE.txt</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/markdown-it/uc.micro">https://github.com/markdown-it/uc.micro</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>util-deprecate</p>
</td>
<td width="419">
<p>Copyright &copy; 2014 Nathan Rajlich.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/TooTallNate/util-deprecate/blob/master/LICENSE">https://github.com/TooTallNate/util-deprecate/blob/master/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/TooTallNate/util-deprecate">https://github.com/TooTallNate/util-deprecate</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>Vue</p>
</td>
<td width="419">
<p>Copyright &copy; 2013-present, Yuxi (Evan) You.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/vuejs/vue/blob/main/LICENSE">https://github.com/vuejs/vue/blob/main/LICENSE</a>.</p>
<p>Copyright holder's websites: <a href="https://github.com/vuejs/vue">https://github.com/vuejs/vue</a>, <a href="https://v2.vuejs.org">https://v2.vuejs.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>vue-apexcharts</p>
</td>
<td width="419">
<p>Copyright &copy; 2018 ApexCharts.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/apexcharts/vue-apexcharts/blob/master/LICENSE">https://github.com/apexcharts/vue-apexcharts/blob/master/LICENSE</a>.</p>
<p>Copyright holder's websites: <a href="https://github.com/apexcharts/vue-apexcharts">https://github.com/apexcharts/vue-apexcharts</a>, <a href="https://apexcharts.com">https://apexcharts.com</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>vue-draggable-resizable</p>
</td>
<td width="419">
<p>Copyright &copy; 2018 Maurizio Bonani.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/mauricius/vue-draggable-resizable/blob/master/LICENSE">https://github.com/mauricius/vue-draggable-resizable/blob/master/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/mauricius/vue-draggable-resizable">https://github.com/mauricius/vue-draggable-resizable</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>vue-i18n</p>
</td>
<td width="419">
<p>Copyright &copy; 2018 Maurizio Bonani.</p>
<p>Licensed under the MIT License.</p>
<p>https://github.com/mauricius/vue-draggable-resizable/blob/master/LICENSE.</p>
<p>Copyright holder's website: <a href="https://github.com/mauricius/vue-draggable-resizable">https://github.com/mauricius/vue-draggable-resizable</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>vue-meta</p>
</td>
<td width="419">
<p>Copyright &copy; 2016 Kazuya kawaguchi.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/kazupon/vue-i18n/blob/v8.x/LICENSE">https://github.com/kazupon/vue-i18n/blob/v8.x/LICENSE</a>.</p>
<p>Copyright holder's websites: <a href="https://github.com/kazupon/vue-i18n">https://github.com/kazupon/vue-i18n</a>, <a href="https://kazupon.github.io/vue-i18n">https://kazupon.github.io/vue-i18n</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>vue-router</p>
</td>
<td width="419">
<p>Copyright &copy; 2013-present Evan You.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/vuejs/vue-router/blob/dev/LICENSE">https://github.com/vuejs/vue-router/blob/dev/LICENSE</a>.</p>
<p>Copyright holder's websites: <a href="https://github.com/vuejs/vue-router">https://github.com/vuejs/vue-router</a>, <a href="https://v3.router.vuejs.org">https://v3.router.vuejs.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>vue-spinner</p>
</td>
<td width="419">
<p>Copyright &copy; 2015 Greyby.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/greyby/vue-spinner/blob/master/LICENSE">https://github.com/greyby/vue-spinner/blob/master/LICENSE</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/greyby/vue-spinner">https://github.com/greyby/vue-spinner</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>vue-sse</p>
</td>
<td width="419">
<p>Copyright &copy; 2021 James Churchard.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/tserkov/vue-sse/blob/v2/LICENSE.md">https://github.com/tserkov/vue-sse/blob/v2/LICENSE.md</a>.</p>
<p>Copyright holder's website: <a href="https://github.com/tserkov/vue-sse">https://github.com/tserkov/vue-sse</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>vue-the-mask</p>
</td>
<td width="419">
<p>Copyright &copy; Org.webjars.npm Group.</p>
<p>Licensed under the MIT License.</p>
<p>https://vuejs-tips.github.io/vue-the-mask.</p>
<p>Copyright holder's website: <a href="https://github.com/vuejs-tips/vue-the-mask">https://github.com/vuejs-tips/vue-the-mask</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>Vuelidate</p>
</td>
<td width="419">
<p>Copyright &copy; 2016 Vuelidate.</p>
<p>Licensed under the MIT License.</p>
<p>https://github.com/vuelidate/vuelidate/blob/next/LICENSE.</p>
<p>Copyright holder's website: <a href="https://github.com/vuelidate/vuelidate">https://github.com/vuelidate/vuelidate</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>Vuetify</p>
</td>
<td width="419">
<p>Copyright &copy; 2016-2023 John Jeremy Leider.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/vuetifyjs/vuetify/blob/master/LICENSE.md">https://github.com/vuetifyjs/vuetify/blob/master/LICENSE.md</a>.</p>
<p>Copyright holder's websites: <a href="https://vuetifyjs.com">https://vuetifyjs.com</a>, <a href="https://github.com/vuetifyjs/vuetify">https://github.com/vuetifyjs/vuetify</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>Vuex</p>
</td>
<td width="419">
<p>Copyright &copy; 2015-present Evan You.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/vuejs/vuex/blob/main/LICENSE">https://github.com/vuejs/vuex/blob/main/LICENSE</a>.</p>
<p>Copyright holder's websites: <a href="https://vuex.vuejs.org">https://vuex .vuejs.org</a>, <a href="https://github.com/vuejs/vuex">https://github.com/vuejs/vuex</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>`
